import axiosInstance from "./axiosInstance";

export const post = async (url, params) => {
  return await axiosInstance
    .post(url, params) // Use POST instead of GET
    .then((res) => {
      return res.data; // Return the response data
    })
    .catch((error) => {
      throw error; // Throw the error to handle it in the calling function
    });
};

export const get = async (url, params) => {
  return await axiosInstance
    .get(url, { params }) // Use GET with params
    .then((res) => {
      return res.data; // Return the response data
    })
    .catch((error) => {
      throw error; // Throw the error to handle it in the calling function
    });
};
